import { contractOutput } from '#backend/contract';
import { MonitoringFileValidation } from '#backend/entity/loaded/harvest-monitoring/MonitoringFileValidation';
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

// Get the full batch monitoring request type
type BatchMonitoringRequest = contractOutput['monitoring']['byId'];
// Extract the individual MonitoringArea type from the monitoringAreas array
type MonitoringArea = NonNullable<
  NonNullable<BatchMonitoringRequest>['monitoringAreas']
>[0];

@Component({
  selector: 'app-detail-monitoring-validation',
  standalone: true,
  imports: [MatRadioModule, CommonModule],
  templateUrl: './detail-monitoring-validation.component.html',
  styleUrl: './detail-monitoring-validation.component.scss',
})
export class DetailMonitoringValidationComponent {
  monitoring = input<MonitoringArea>();
  validation = input<MonitoringFileValidation>();
}
